<template>
  <v-select
    label="text"
    :options="estados "
    :reduce="estado => mode === 'object' ? estado : estado.id " 
    @search="debounceSearch"
    @input="setChange"
    v-model="selected"
  >
    <template #no-options="{ search }">
      No se encontraron resultados para <strong>{{ search }}</strong>
    </template>
    <template #search="{ attributes, events }">
      <input class="vs__search" v-bind="attributes" v-on="events" />
    </template>
  </v-select>
</template>

<script>

import {isEmpty, debounce} from 'lodash';
import VSelect from 'vue-select';
import dataSourceService from "../../services/dataSourceService";

export default {
  props: ["value", "mode","validator"],
  components : {VSelect},
  data() {
    return {
          data_sources_estadoCivil: {
                estado: '/api/estadoCivil/data-source-estadoCivil',
            },
      
      estados: [],
     selected: this.value,
       search: '',
    };
  },
  created() {
    this.debounceSearch = debounce(this.buscarEstado, 300);
  },
  watch: {

    value: async function (value) {
      if (this.mode === "object") {
        if (isEmpty(value) || value === undefined || value === null) {
          this.selected = this.mode === "object" ? {} : "";
          return;
        }
      } else {
        if (value === "" || value === undefined || value === null) {
          this.selected = this.mode === "object" ? {} : "";
          return;
        }
      }

      let id = this.mode === "object" ? value.id : value;

      if (isEmpty(this.estados.find((x) => x.id === id))) {
        const response =await dataSourceService.verEstadoCivil(id);
       
          this.estados.push({
            id: response.data.id,
            text: `${response.data.id} ${response.data.descripcion}`,
          });

          this.selected = {
            id: response.data.id,
            text: `${response.data.id} ${response.data.descripcion}`,
          };
          this.$emit("input", value);
      }


      
    },
  },
 
  methods: {
        async buscarEstado(search, loading) {
            try {
              loading(true);
              const response = await dataSourceService.dataSourceEstadoCivil(`?s=${escape(search)}`);
              this.estados = response.data.results;
              loading(false);
            } catch (error) {
              loading(false);
              alert("Ocurrio un error, por favor intente nuevamente");
            }
    
        },
    setChange(value) {
     this.$emit("update-value", value);
    },
    
    
  },
 computed: {
    classObject: function () {
      if (this.validator === undefined || this.validator === null) {
        return "";
      }
      return this.validator.$error ? "v-select-error is-invalid" : "is-valid";
    },
  },

};
</script>
<style scoped>
</style>
